import React from 'react';

export default React.memo(function PrepHeader({ session, tColor, products, totalQty, nbAmb, nbFroid, nbCartons, nbCartonsVrac, reliquats, newCaisse, onBack, onRelease }) {
  const totalCaisses = nbAmb + nbFroid;
  const totalCartons = nbCartons + (nbCartonsVrac || 0);

  return (
    <>
      {/* Header — nom + adresse + tournée */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 2 }}>
        <button onClick={() => onBack()} style={{ background: 'none', border: 'none', fontSize: 24, cursor: 'pointer', color: '#9CA3AF', padding: '8px 12px 8px 0', minWidth: 44, minHeight: 44 }}>←</button>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 15, fontWeight: 600, color: '#1A1D23' }}>{session.partner_name}</div>
        </div>
        {session.tournee && (
          <div style={{ padding: '3px 8px', borderRadius: 6, background: tColor + '18', color: tColor, fontSize: 10, fontWeight: 700, flexShrink: 0 }}>
            {session.tournee === 'IMPERATIFS' ? 'Imp.' : 'T' + session.tournee}
          </div>
        )}
      </div>

      {/* Bouton libérer — discret mais visible */}
      {onRelease && session.status !== 'prete' && session.status !== 'depart_valide' && (
        <button onClick={onRelease} style={{
          padding: '6px 12px', borderRadius: 8, marginBottom: 8,
          border: '1px solid #C0392B', background: '#FDECEA',
          color: '#C0392B', fontSize: 11, fontWeight: 600,
          cursor: 'pointer', fontFamily: 'inherit',
        }}>Je libère cette pharmacie</button>
      )}

      {/* Sous-ligne : adresse + refs */}
      <div style={{ fontSize: 11, color: '#9CA3AF', marginBottom: 8, paddingLeft: 2 }}>
        {session.adresse || ''}
        {session.order_refs && session.order_refs.length > 0 && (
          <span> · {session.order_refs.join(' · ')}</span>
        )}
      </div>

      {/* Alerte si partie */}
      {session.status === 'depart_valide' && (
        <div style={{
          padding: '10px 14px', borderRadius: 10, marginBottom: 8,
          background: '#D6EAF8', border: '1.5px solid #85B7EB',
          fontSize: 13, fontWeight: 600, color: '#1A5276', textAlign: 'center',
        }}>
          Cette commande est partie en livraison
        </div>
      )}

      {/* Stats grille 4 colonnes */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 12 }}>
        <div style={{ flex: 1, padding: '6px 0', background: 'white', borderRadius: 8, textAlign: 'center', border: '0.5px solid #E8E8EE' }}>
          <div style={{ fontSize: 16, fontWeight: 600 }}>{products.length}</div>
          <div style={{ fontSize: 9, color: '#9CA3AF' }}>produit{products.length > 1 ? 's' : ''}</div>
        </div>
        <div style={{ flex: 1, padding: '6px 0', background: 'white', borderRadius: 8, textAlign: 'center', border: '0.5px solid #E8E8EE' }}>
          <div style={{ fontSize: 16, fontWeight: 600 }}>{totalQty}</div>
          <div style={{ fontSize: 9, color: '#9CA3AF' }}>boîte{totalQty > 1 ? 's' : ''}</div>
        </div>
        <div style={{ flex: 1, padding: '6px 0', background: 'white', borderRadius: 8, textAlign: 'center', border: '0.5px solid #E8E8EE' }}>
          <div style={{ fontSize: 16, fontWeight: 600, color: totalCaisses > 0 ? '#1A5276' : undefined }}>{totalCaisses}</div>
          <div style={{ fontSize: 9, color: '#9CA3AF' }}>caisses</div>
        </div>
        <div style={{ flex: 1, padding: '6px 0', background: 'white', borderRadius: 8, textAlign: 'center', border: '0.5px solid #E8E8EE' }}>
          <div style={{ fontSize: 16, fontWeight: 600, color: totalCartons > 0 ? '#7D5A0A' : undefined }}>{totalCartons}</div>
          <div style={{ fontSize: 9, color: '#9CA3AF' }}>cartons</div>
        </div>
      </div>

      {/* Reliquats */}
      {reliquats.length > 0 && (
        <div style={{
          padding: '10px 12px', borderRadius: 10, marginBottom: 10,
          background: '#FDECEA', border: '1.5px solid #F5AFA7',
        }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: '#922B21', marginBottom: 4 }}>
            Reliquat — {reliquats.length} produit{reliquats.length > 1 ? 's' : ''} à ajouter
          </div>
          {reliquats.map((r) => {
            const ageDays = r.created_at ? Math.floor((Date.now() - new Date(r.created_at).getTime()) / 86400000) : 0;
            const isOld = ageDays >= 3;
            return (
              <div key={r.id} style={{
                padding: '5px 8px', borderRadius: 6, marginBottom: 2,
                background: isOld ? '#FEF3CD' : 'white',
                border: '1px solid ' + (isOld ? '#F0C36D' : '#F5AFA7'), fontSize: 11,
                display: 'flex', alignItems: 'center', gap: 6,
              }}>
                <span style={{ fontWeight: 600, flex: 1 }}>{r.product_name}</span>
                {isOld && <span style={{ fontSize: 9, fontWeight: 700, color: '#D4680A', background: '#FEF3CD', padding: '1px 5px', borderRadius: 4, border: '1px solid #F0C36D' }}>{ageDays}j</span>}
              </div>
            );
          })}
        </div>
      )}
    </>
  );
});